export default __webpack_public_path__ + "static/media/BOHEM.d4cef8b2.png";